import {
  type CredentialUpdateSessionResponseDto,
  updateCredentialsOptions,
} from '@helios/frontend-api-v2-client';
import { useQueryClient } from '@tanstack/react-query';

interface UseCredentialUpdateSessionProps {
  getCredentialUpdateUrl: (params: { id: string }) => Promise<CredentialUpdateSessionResponseDto>;
}

export const useCredentialUpdateSession = (): UseCredentialUpdateSessionProps => {
  const queryClient = useQueryClient();

  const getCredentialUpdateUrl = async ({ id }: { id: string }) =>
    queryClient.fetchQuery({
      ...updateCredentialsOptions({ path: { id } }),
      staleTime: Infinity,
      gcTime: Infinity,
      retry: false,
    });

  return { getCredentialUpdateUrl };
};
